import PropTypes from 'prop-types';
export default PropTypes.shape({
  REGION: PropTypes.shape({}),
  DIVISION: PropTypes.shape({}),
  DISTRICT: PropTypes.shape({}),
  STREET: PropTypes.shape({})
});